import {WatchService} from "../watch.service";
import {IAction, IMarketTemplate, IQuestRewardTemplate, IWorkplaceLevelSettings} from "../../definitions";
import * as _ from "underscore";
import {BaseUtils} from "./base.utils";
import {GO_COMPONENTS} from "../../enums/e-game-objects";
import {SHOP_CATEGORIES} from "../../enums/e-shop-categories";
import {MODIFIER_TYPES} from "../../enums/e-modifiers";

const KEY_REPAIR_ACTION = "repairAction";


export class GameObjectUtils extends BaseUtils {
  constructor(watchService: WatchService) {
    super(watchService)
  }


  hasRepairAction(component: any): boolean {
    return _.has(component, KEY_REPAIR_ACTION);
  }

  createWorkplaceLevelSettings():IWorkplaceLevelSettings
  {
    return <IWorkplaceLevelSettings> {
      freeSlots: 0,
      productions: []
    }
  }

  createEmptyAction(): IAction {
    return <IAction>{
      restrictions: [],
      accelerateCost: 0,
      time: 0,
      id: -1,
      workers: 0,
      type: 0,
      spendings: [],
      reward: []
    };
  }

  createEmptyMarketTemplate(): IMarketTemplate {
    return <IMarketTemplate>{
      restrictions:[],
      name:'New Template',
      id:-1,
      min:0,
      max:0,
      powerKoeff:0,
      chance:0,
      superProfitChance:0,
      superProfitKoeff:0,
      templateType:1
    }
  }

  createEmptyQuestRewardTemplate(): IQuestRewardTemplate {
    return <IQuestRewardTemplate>{
      id:-1,
      slotsCount:0,
      name: 'New Template'
    }
  }


  toggleRepairAction(component: any) {
    if (this.hasRepairAction(component)) {
      delete component[KEY_REPAIR_ACTION];
    } else {
      component[KEY_REPAIR_ACTION] = this.createEmptyAction();
    }
    this.notify();
  }


  removeComponent(document: any, componentType: string) {
    delete document[componentType];
    this.notify();
  }


  addEntryToFloatingCostChanges(changes:any[]):void {
    changes.push({
      spendings: [],
      restrictions: []
    });
    this.notify();
  }


  addActionTo(document: any, pointer: string) {
    this.push(document, pointer, this.createEmptyAction());
  }

  addMarketTemplateTo(document: any, pointer: string) {
    this.push(document, pointer, this.createEmptyMarketTemplate());
  }

  addQuestRewardTemplateTo(document: any, pointer: string) {
    this.push(document, pointer, this.createEmptyQuestRewardTemplate());
  }


  initializeComponent(document: any, componentType: string) {
    switch (componentType) {

      case GO_COMPONENTS.BOUNDS:
        document[componentType] = {width: 0, height: 0};
        break;

      case GO_COMPONENTS.LAIR:
        document[componentType] = {period: 0};
        break;

      case GO_COMPONENTS.STORAGE:
        document[componentType] = {limits: []};
        break;


      case GO_COMPONENTS.HOUSE:
        document[componentType] = {livingWorkers: 0};
        break;

      case GO_COMPONENTS.INITIAL:
        document[componentType] = {level: 0};
        break;

      case GO_COMPONENTS.LIMITED:
        document[componentType] = {limit: 0};
        break;

      case GO_COMPONENTS.SHOP:
        document[componentType] = {category: SHOP_CATEGORIES.HIDDEN};
        break;

      case GO_COMPONENTS.INFLUENCE_SENDER:
        document[componentType] = {
          modificator: MODIFIER_TYPES.ACTION_INCOME,
          strength: 0,
          outModificatorRadius: 0
        };
        break;

      case GO_COMPONENTS.LIVE_DECOR:
        document[componentType] = {lifetime:0, cooldown:0, speed:0 };
        break;

      case GO_COMPONENTS.FLOATING_COST:
        document[componentType] = {changes: []};
        break;

      case GO_COMPONENTS.PASTURE:
        document[componentType] = {
          animalLimits: [],
          animalId: 0,
          regionRadius: 0
        };
        break;

      case GO_COMPONENTS.RES_TRANSACTION:
        document[componentType] = {
          restrictions: [],
          spendings: [],
          reward: []
        };
        break;

      case GO_COMPONENTS.PLANT:
        document[componentType] = {
          action: this.createEmptyAction()
        };
        break;

      case GO_COMPONENTS.RESOURCE:
        document[componentType] = {
          deep: 0,
          storable: false,
          xp: 0,
          weight: 0,
          sellPriceGold: 0,
          ownerId: 0,
          skipCost: 0,
          source: [],
        };
        break;

      case GO_COMPONENTS.WORK:
        document[componentType] = {
          productionQueueSlots: [],
          freeSlots: 0,
          upgradeActions: [],
          actions: [],
          repairAction: []
        };
        break;

      case GO_COMPONENTS.MOVE:
        document[componentType] = {
          runSpeed: 0,
          walkSpeed: 0,
          speedKoeff: 1
        }
        break;

      case GO_COMPONENTS.TAGS:
        document[componentType] = [];
        break;

      case GO_COMPONENTS.GAME_EVENTS:
        document[componentType] = [];
        break;

      case GO_COMPONENTS.ORDERS:
        document[componentType] = {
          templates:[],
          cooldownTime: -1
        }
        break;

      case GO_COMPONENTS.EVENT_STARTER:
        document[componentType] = []
        break;

      case GO_COMPONENTS.RENDER:
        document[componentType] = { };
        break;

      case GO_COMPONENTS.GAME_TASK:
        document[componentType] = {
          oneTime: true,
          restrictions: {},
          orRestrictions: {},
          finishRestrictions: {},
          timeParameters: {
            timeout: 0,
            activePeriodStart: null,
            activePeriodEnd: null
          }
        }
        break;

      case GO_COMPONENTS.PERIODICAL_REWARD:
        document[componentType] = {
          reward:[],
          periods:0,
          restrictions:[]
        };
        break;

      case GO_COMPONENTS.INFLUENCE_RECEIVER:
        document[componentType] = {
          receiveOnly:[],
          ignore:[]
        }
    }
    this.notify();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory-service-impl/gameObject.utils.ts